import React from "react";
import ContactFormPage from "./ContactFormPage";

const AddContact = () => {
  return (
    <>
      <ContactFormPage action="Add" />
    </>
  );
};

export default AddContact;


